import React from "react";
import MapContainer from "../containers/Map/index";

const MapPage = (props) => {
  return (
    <>
      <MapContainer {...props}/>
    </>
  );
};

export default MapPage;
